
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse",
      function () {
        return require("private-next-pages/browse.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse"])
      });
    }
  